import React, { useEffect } from 'react'
import "./AboutUs.scss"
import '../../../../src/assets/css/cmsbanner.css';

function AboutBanner() {
    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    return (
        <>
            <div className="cms-pages-baner about-baner">
                <div className="theme__container">
                    <div className='cms-content-heading'>
                        <h2 className='f-size-180 2xl:text-9xl lg:text-7xl md:text-5xl text-3xl  text-white bold  xl:mb-5 mb-3'>
                        معلومات   
                        </h2>
                        <p className='2xl:text-5xl xl:text-4xl md:text-3xl text-2xl font-light text-white'>
                        هل ترغب بالتواصل مع م.نبيلة؟ الآن يمكنك التواصل مباشرة مع م.نبيلة
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutBanner
